import { render, staticRenderFns } from "./camPrecio.vue?vue&type=template&id=1d8251f7&scoped=true"
import script from "./camPrecio.vue?vue&type=script&lang=js"
export * from "./camPrecio.vue?vue&type=script&lang=js"
import style0 from "./camPrecio.vue?vue&type=style&index=0&id=1d8251f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8251f7",
  null
  
)

export default component.exports